import { type StoreHuman } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { extractText } from './extract-text';

/**
 * Checks whether a StoreHuman message has no meaningful content to display.
 * Returns true if the message has no text content (null, empty string, or
 * ADF doc with no text) and no file uploads.
 */
export const isMessageEmpty = (message: StoreHuman): boolean => {
	const { content, file_uploads } = message.content;

	if (file_uploads?.length) {
		return false;
	}

	if (content == null || content === '') {
		return true;
	}

	if (typeof content === 'object' && content.type === 'doc' && extractText(content) === '') {
		return true;
	}

	return false;
};
